"use client";

import NextLink from "next/link";
import { useState, type ComponentProps } from "react";
import { useLocale } from "@/lib/i18n/client";
import { localizePath } from "@/lib/i18n/paths";

// Reemplazo de next/link que agrega el prefijo de idioma a las rutas
// internas ("/eventos" → "/en/eventos"). Mismas props que next/link. Es de
// cliente para leer el idioma del contexto, pero se puede usar igual desde
// componentes de servidor.
//
// Prefetch solo con intención (mouse encima, foco o primer toque), no al
// aparecer en pantalla: con el prefetch por defecto cada tarjeta visible
// pedía su página a una function de Netlify, y una lista de eventos o de
// comunas gastaba decenas por visita. Pasar `prefetch` explícito lo respeta.
export default function Link({ href, prefetch, onMouseEnter, onFocus, onTouchStart, ...props }: ComponentProps<typeof NextLink>) {
  const lang = useLocale();
  const [intent, setIntent] = useState(false);
  const localized =
    typeof href === "string"
      ? localizePath(href, lang)
      : href.pathname
        ? { ...href, pathname: localizePath(href.pathname, lang) }
        : href;
  return (
    <NextLink
      href={localized}
      prefetch={prefetch !== undefined ? prefetch : intent ? null : false}
      onMouseEnter={(e) => {
        setIntent(true);
        onMouseEnter?.(e);
      }}
      onFocus={(e) => {
        setIntent(true);
        onFocus?.(e);
      }}
      onTouchStart={(e) => {
        setIntent(true);
        onTouchStart?.(e);
      }}
      {...props}
    />
  );
}
